/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {styled} from '@mui/material';
import {FC} from 'react';
import AudioPlayer, {RHAP_UI} from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PauseIcon from '@mui/icons-material/Pause';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import FastForwardIcon from '@mui/icons-material/FastForward';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import LoopIcon from '@mui/icons-material/Loop';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';

const StyledAudioPlayer = styled(AudioPlayer)(({theme}) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.grey[100],
  boxShadow: 'none',
  width: '100%',
  '.rhap_time': {
    color: theme.palette.text.primary,
  },
  '.rhap_main-controls-button': {
    color: theme.palette.text.primary,
  },
  '.rhap_volume-button': {
    color: theme.palette.text.primary,
  },
  '.rhap_volume-bar': {
    backgroundColor: theme.palette.text.primary,
  },
  '.rhap_button-clear': {
    color: theme.palette.text.primary,
  },
  '.rhap_main-controls': {
    width: '100%',
  },
  '.rhap_total-time': {
    marginRight: 8,
  },
}));

const customIcons = {
  play: <PlayCircleIcon fontSize={'large'} />,
  pause: <PauseIcon fontSize={'large'} />,
  rewind: <FastRewindIcon fontSize={'large'} />,
  forward: <FastForwardIcon fontSize={'large'} />,
  previous: <SkipPreviousIcon fontSize={'large'} />,
  next: <SkipNextIcon fontSize={'large'} />,
  loop: <LoopIcon />,
  volume: <VolumeUpIcon />,
  volumeMute: <VolumeOffIcon />,
};

interface Props {
  audioURL: string;
  onPlay?: () => void;
  onPause?: () => void;
}
const ContactAudioPlayer: FC<Props> = ({audioURL, onPlay, onPause}) => {
  return (
    <StyledAudioPlayer
      src={audioURL}
      autoPlay={false}
      layout={'stacked'}
      progressJumpSteps={{backward: 15000, forward: 15000}}
      customControlsSection={[RHAP_UI.MAIN_CONTROLS]}
      customProgressBarSection={[RHAP_UI.CURRENT_TIME, RHAP_UI.PROGRESS_BAR, RHAP_UI.DURATION, RHAP_UI.VOLUME]}
      onPlay={onPlay}
      onPause={onPause}
      customIcons={customIcons}
    />
  );
};

export default ContactAudioPlayer;
